<template>
  <div class="section-header">
    <div class="title">
      <div v-if="title">{{title}}</div>
      <slot v-if="!title" name="title"/>
    </div>
    <div class="controls">
      <slot/>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string;
}

withDefaults(defineProps<Props>(), {
  title: ''
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use "@/variables.scss" as *;

.section-header {
  text-align: left;
  padding: 0;
  padding-bottom: 3px;
  border-bottom: 2px solid $linkColour;
  font-weight: bold;
  color: $bgColour;
  margin-bottom: 15px;
  margin-top: 15px;
  display:flex;
  align-items: flex-end;
}

.controls {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}

.title {
  margin-right: auto;
}

</style>
